<!--
 * @Author: your name
 * @Date: 2020-11-03 14:43:00
 * @LastEditTime: 2021-02-25 10:10:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xy_project\src\App.vue
-->
<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <loading v-show="isLoading"></loading>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import loading from '@/components/Loading.vue'
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  created() {
    
  },
  methods: {
    //重新加载页面请求配置
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      })
    }
  },
  computed: {
    ...mapState(['isLoading'])
  },
  components: {
    loading
  }
}
</script>
<style lang="less" scoped>
#app {
  width: 100%;
  height: 100%;
}
</style>
